import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ProspectData {
  id?: number;
  email: string;
  firstName?: string;
  lastName?: string;
  telephone?: string;
  marque?: string;
  produit?: string;
  card?: {
    cardToken?: string;
    cardHolder?: string;
    cardLast4?: string;
    cardExpiry?: string;
    cardType?: string;
  };
}

export interface LeadData {
  id?: string;
  id_site: number;
  produit: string;
  status: string;
  source: string;
  type: string;
  notes: string;
}

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {
  private prospectDataSubject = new BehaviorSubject<ProspectData | null>(null);
  private leadDataSubject = new BehaviorSubject<LeadData | null>(null);
  private clientIdSubject = new BehaviorSubject<number | null>(null);

  public prospectData$ = this.prospectDataSubject.asObservable();
  public leadData$ = this.leadDataSubject.asObservable();
  public clientId$ = this.clientIdSubject.asObservable();

  setProspectData(data: ProspectData) {
    this.prospectDataSubject.next(data);
  }

  getProspectData(): ProspectData | null {
    return this.prospectDataSubject.value;
  }

  setLeadData(data: LeadData) {
    this.leadDataSubject.next(data);
  }

  getLeadData(): LeadData | null {
    return this.leadDataSubject.value;
  }

  setClientId(data: number) {
    this.clientIdSubject.next(data);
  }

  getClientId(): number | null {
    return this.clientIdSubject.value;
  }

  clearProspectData() {
    this.prospectDataSubject.next(null);
  }

  clearLeadData() {
    this.leadDataSubject.next(null);
  }

  clearAllData() {
    this.prospectDataSubject.next(null);
    this.leadDataSubject.next(null);
  }
} 